import { render, staticRenderFns } from "./StudentList.vue?vue&type=template&id=773b802e"
import script from "./StudentList.vue?vue&type=script&lang=js"
export * from "./StudentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('773b802e')) {
      api.createRecord('773b802e', component.options)
    } else {
      api.reload('773b802e', component.options)
    }
    module.hot.accept("./StudentList.vue?vue&type=template&id=773b802e", function () {
      api.rerender('773b802e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/test/manytomany/StudentList.vue"
export default component.exports